import { TOKEN_SYMBOL_ICON_PATH, TRX_SYMBOL_ICON_PATH } from '@/consts/imgPath';
import { IResponseBalance, IResponseUser } from '@/core/domain/entities/user';
import * as ViewModel from '@/core/presenter/viewModel';
import { getStores } from '@/stores';
import { formatNumber } from '@/utils';
import dayjs from 'dayjs';

/**
 * 유저 viewModel 변환 함수
 *
 * @export
 * @param {IResponseUser} resData
 * @return {*}  {ViewModel.IUser}
 */
export function toUser(resData: IResponseUser): ViewModel.IUser {
  const ret: ViewModel.IUser = {
    id: resData.id,
    phone: resData.phone,
    name: resData.name,
    status: resData.status,
    trxAddress: resData.trx_address,
    address: resData.balance.address,
    totalBalance: formatNumber(resData.balance.trxKRW + resData.balance.tokenKRW),
    trxBalance: resData.balance.trxBalance,
    trxKrw: formatNumber(resData.balance.trxKRW),
    tokenBalance: resData.balance.tokenBalance,
    tokenKrw: formatNumber(resData.balance.tokenKRW),
    trxAsset: {
      name: '트론',
      symbol: 'TRX',
      balance: resData.balance.trxBalance,
      krw: formatNumber(resData.balance.trxKRW),
      iconPath: TRX_SYMBOL_ICON_PATH,
    },
    tokenAsset: {
      name: '더블에스',
      symbol: 'DBS',
      balance: resData.balance.tokenBalance,
      krw: formatNumber(resData.balance.tokenKRW),
      iconPath: TOKEN_SYMBOL_ICON_PATH,
    },
    lastLoginTime: resData.lastLoginTime ? dayjs(resData.lastLoginTime).format('YYYY.MM.DD HH:mm') : '',
  };

  return ret;
}

/**
 * 유저 자산 viewModel 변환 함수
 *
 * @export
 * @param {IResponseBalance} resData
 * @return {*}  {ViewModel.IMyAsset}
 */
export function toMyAsset(resData: IResponseBalance): ViewModel.IMyAsset {
  const { presentationStore } = getStores();

  const ret: ViewModel.IMyAsset = {
    trxAsset: {
      name: '트론',
      symbol: 'TRX',
      balance: resData.trxBalance,
      krw: formatNumber(resData.trxKRW),
      iconPath: TRX_SYMBOL_ICON_PATH,
      trxPrice: presentationStore.balance?.trxPrice,
    },
    tokenAsset: {
      name: '더블에스',
      symbol: 'DBS',
      balance: resData.tokenBalance,
      krw: formatNumber(resData.tokenKRW),
      iconPath: TOKEN_SYMBOL_ICON_PATH,
      tokenPrice: presentationStore.balance?.tokenPrice,
    },
  };

  return ret;
}
